/**
 * @generated SignedSource<<ae62771b1801bff4c7580c32cffbe8fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderAmountFragment$data = {
  readonly subAmount: number;
  readonly taxAmount: number;
  readonly totalAmount: number;
  readonly discountAmount: number;
  readonly grandAmount: number;
  readonly currencyCode: string;
  readonly paymentTerms: any | null;
  readonly " $fragmentType": "salesOrderAmountFragment";
};
export type salesOrderAmountFragment$key = {
  readonly " $data"?: salesOrderAmountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderAmountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "salesOrderAmountFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discountAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grandAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentTerms",
      "storageKey": null
    }
  ],
  "type": "SalesOrder",
  "abstractKey": null
};

(node as any).hash = "72a3f7012678366f2cdbe3d1c299d796";

export default node;
